import React, { useEffect, useRef, useState } from "react";
import GetSvgIcon from "../assets/images/svgList";
import DragAndDropFileSelectedLayout from "./DragAndDropFileSelectedLayout";

interface IDragAndDropButtonLayout {
  acceptableFiles: string[];
  dragAndDropModalMessage: string;
  forCrop: boolean;
  data?: any;
  multiple?: boolean;
  handleClose?: () => void;
}

const DragAndDropLayout = (props: IDragAndDropButtonLayout) => {
  const {
    acceptableFiles,
    dragAndDropModalMessage = "",
    forCrop,
    data,
    multiple = true,
    handleClose ,
  } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [files, setFiles] = useState<File[] | null>(null);
  const [notSupportedMssg, setNotSupportedMssg] = useState(false);

  useEffect(() => {
    data(files);
  }, [files, setFiles]);

  const handelDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handelDrop = (e: any, dropFromInputLink: boolean) => {
    e.preventDefault();
    let droppedFiles: FileList | null = null;

    if (dropFromInputLink) {
      droppedFiles = (e as React.ChangeEvent<HTMLInputElement>).target.files;
    } else {
      droppedFiles = (e as React.DragEvent<HTMLDivElement>).dataTransfer.files;
    }

    if (droppedFiles) {
      const validFiles = Array.from(droppedFiles).filter((file) => {
        const fileExtension = file.name.split(".").pop()?.toUpperCase();
        return acceptableFiles.includes(fileExtension || "");
      });

      if (validFiles.length > 0) {
        setFiles(validFiles);
        setNotSupportedMssg(false);
      } else {
        setNotSupportedMssg(true);
      }
    }
  };

  return (
    <>
      {" "}
      {!files ? (
        <div className="dragAndDropLayout p-3">
          <div
            className="drop-zone p-3 cursor-pointer"
            onDragOver={handelDragOver}
            onDrop={(event) => {
              handelDrop(event, false);
            }}
          >
            <div className="d-flex justify-content-center logo mb-2">
              {GetSvgIcon.GlobalUpArrow}
            </div>
            <div className="d-flex justify-content-center message">
              {dragAndDropModalMessage}
            </div>
            <input
              type="file"
              multiple={multiple}
              hidden
              onChange={(event) => {
                handelDrop(event, true);
              }}
              ref={inputRef}
            ></input>
            <a
              className="d-flex justify-content-center"
              onClick={() => inputRef.current?.click()}
            >
              Browse file
            </a>
            <div className="d-flex justify-content-center">
              <p className={`ms-1 ${notSupportedMssg ? `text-danger` : ``}`}>
                {notSupportedMssg ? "Only supports " : ""}
                {acceptableFiles?.map((e, index) => (
                  <>
                    {index === 0
                      ? e
                      : index === acceptableFiles.length - 1
                      ? ` or ${e}`
                      : `, ${e}`}
                  </>
                ))}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <DragAndDropFileSelectedLayout
          selectedFiles={files}
          forCrop={forCrop}
          setFiles={setFiles}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default DragAndDropLayout;
